<div class="card mb-5" *ngIf="data">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title d-flex flex-column">
      <h4>{{data.title}}</h4>
    </div>
  </div>
  <div class="card-body">
    <div [id]="data.widgetId" style="height: 300px; width: 100%;"></div>
  </div>
</div>
